import { Component, OnInit, Inject, PLATFORM_ID, OnDestroy } from '@angular/core'
import { SharedService } from '@flowaccount/landing'
import { ActivatedRoute, Params, Router } from '@angular/router'
import { TranslateService } from '@ngx-translate/core'
import { Title, SafeHtml } from '@angular/platform-browser'
import { SEOService } from '@flowaccount/landing'
import { HttpClient } from '@angular/common/http'
import videoData from '../../../../assets/tutorials/tutorials.json'
import videoList from '../../../../assets/tutorials/tutorialsV2.json'
import { environment } from '../../../../environments/environment'
import { Observable, Subscription } from 'rxjs'
import { videoDescription } from '../../../models/tutorialsVideo'

@Component({
  selector: 'flowaccount-view-tutorial',
  templateUrl: './view-tutorial.component.html',
  styleUrls: ['./view-tutorial.component.scss'],
})
export class ViewTutorialComponent implements OnInit, OnDestroy {
  public id: string
  public currentTutorial: any
  public currentDescription: any
  public jsonLD: SafeHtml

  // เนื้อหาวิดีโอปี 2021 (boolean นี้มี 2 ที่  tutorial และ view-tuterial)
  public isTutorialVideo2021 = true
  public isShowVideoBefore2021 = false
  private langChangeSubscription: Subscription
  private routeParamsSubscription: Subscription
  constructor(
    private activatedRoute: ActivatedRoute,
    private sharedService: SharedService,
    public translate: TranslateService,
    private titleService: Title,
    private http: HttpClient,
    @Inject(PLATFORM_ID) private platformId,
    private seoService: SEOService,
    private router: Router,
  ) {
    this.langChangeSubscription = this.translate.onLangChange.subscribe(() => {
      this.setMeta()
    })
    this.routeParamsSubscription = this.activatedRoute.params.subscribe((params: Params) => {
      this.id = params['id']
    })
  }

  public getSeminarList(): Observable<any> {
    return this.http.get(environment.seminarFilePath)
  }

  ngOnInit() {
    // เนื้อหา Video อัพเดทปี 09-2021
    this.showVideoDetail2021()

    // ถ้าให้โชว์ Video ก่อน 2021 และ ไม่พบในวีดีโอชุดปัจจุบัน
    if (this.isShowVideoBefore2021 && this.currentTutorial === undefined) {
      // เนื้อหา Video เก่า
      this.showVideoDetail2020()
      this.isTutorialVideo2021 = false // ปรับให้แสดงหน้า detail เป็นแบบเก่า
    }

    // ไม่พบ Video ให้แสดง 404
    if (this.currentTutorial === undefined) {
      this.router.navigate(['notfound'])
    }
  }
  setMeta() {
    const title = this.translate.instant('metatitle-Video-Dynamic').replace('{0}', this.currentTutorial.title)
    const description = this.translate.instant(this.currentTutorial.description_1)
    const imageUrl =
      'https://flowaccountcdn.com/new_landing/image/tutorials/SS1/FlowAccount%20Business%20Suite%20ระบบริหารธุรกิจ%20SME.jpg'
    const canonicalUrl = 'https://flowaccount.com/blog/'

    this.titleService.setTitle(title)
    this.seoService.createMetaTag(title, description)
    this.seoService.createOg(imageUrl, title, description)
    this.seoService.setCanonicalUrl(canonicalUrl)
  }

  showVideoDetail2021() {
    const list = videoList.allVideo.filter((item) => item.slugURL === this.id)
    this.currentTutorial = list[0]
  }

  showVideoDetail2020() {
    const list = videoData.allVideo.filter((item) => {
      if (this.translate.currentLang === 'th') {
        return this.strReplace(item.title) === this.id
      } else {
        return this.strReplace(item.title_en) === this.id
      }
    })

    this.currentTutorial = list[0]
    const description = videoDescription.filter((item) => item.id === this.currentTutorial.descriptionId)
    this.currentDescription = description.length > 0 ? description[0].detail : ''
  }

  getLink() {
    return 'https://www.youtube.com/embed/' + this.currentTutorial.video
  }

  strReplace(string) {
    const re = /[\/\s]/gi
    return string.replace(re, '-')
  }
  ngOnDestroy() {
    this.langChangeSubscription?.unsubscribe()
    this.routeParamsSubscription?.unsubscribe()
  }
}
